import { render, staticRenderFns } from "./BtnObterDotacoesContrato.vue?vue&type=template&id=53acc7f0"
import script from "./BtnObterDotacoesContrato.vue?vue&type=script&lang=js"
export * from "./BtnObterDotacoesContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports